export default function VisaMastercardLogo({
  className,
}: {
  className?: string;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={128}
      height={128}
      viewBox="0 0 128 128"
      fill="none"
      className={className}
    >
      <g clipPath="url(#a)">
        <mask
          id="b"
          width={96}
          height={62}
          x={16}
          y={0}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: "luminance",
          }}
        >
          <path fill="#fff" d="M112 0H16v61.538h96V0Z" />
        </mask>
        <g mask="url(#b)">
          <path
            fill="#1434CB"
            d="M20.923 0h86.154A4.923 4.923 0 0 1 112 4.923v51.692a4.923 4.923 0 0 1-4.923 4.923H20.923A4.923 4.923 0 0 1 16 56.615V4.923A4.923 4.923 0 0 1 20.923 0Z"
          />
          <path
            fill="#fff"
            d="M76.285 17.613c-5.764 0-10.915 2.989-10.915 8.51 0 6.333 9.136 6.77 9.136 9.951 0 1.34-1.535 2.539-4.156 2.539-3.72 0-6.5-1.676-6.5-1.676l-1.19 5.572s3.204 1.415 7.456 1.415c6.302 0 11.26-3.135 11.26-8.751 0-6.691-9.173-7.115-9.173-10.068 0-1.05 1.26-2.199 3.873-2.199 2.949 0 5.355 1.218 5.355 1.218l1.164-5.381s-2.618-1.13-6.31-1.13Zm-52.737.406-.14.813s2.425.444 4.61 1.33c2.812 1.015 3.012 1.606 3.486 3.442l5.16 19.902h6.92l10.658-25.487h-6.903L40.49 35.348l-2.794-14.689c-.257-1.68-1.555-2.64-3.144-2.64H23.548Zm33.47 0-5.415 25.487h6.582l5.396-25.487h-6.564Zm36.711 0c-1.587 0-2.428.85-3.045 2.336l-9.644 23.15h6.903l1.336-3.858h8.41l.811 3.859h6.091l-5.313-25.487h-5.549Zm.898 6.886 2.046 9.564h-5.481l3.435-9.564Z"
          />
        </g>
      </g>
      <g clipPath="url(#c)">
        <mask
          id="d"
          width={96}
          height={62}
          x={16}
          y={66}
          maskUnits="userSpaceOnUse"
          style={{
            maskType: "luminance",
          }}
        >
          <path fill="#fff" d="M112 66H16v61.538h96V66Z" />
        </mask>
        <g mask="url(#d)">
          <path
            fill="#253747"
            d="M20.923 66h86.154A4.923 4.923 0 0 1 112 70.923v51.692a4.923 4.923 0 0 1-4.923 4.923H20.923A4.923 4.923 0 0 1 16 122.615V70.923A4.923 4.923 0 0 1 20.923 66Z"
          />
          <path
            fill="#fff"
            d="M41.976 123.483v-3.562c0-1.362-.83-2.254-2.254-2.254-.712 0-1.487.235-2.02 1.01-.414-.65-1.01-1.01-1.901-1.01-.595 0-1.19.18-1.66.83v-.712h-1.244v5.698h1.244v-3.147c0-1.009.533-1.486 1.363-1.486s1.244.532 1.244 1.486v3.147h1.245v-3.147c0-1.009.595-1.486 1.362-1.486.83 0 1.245.532 1.245 1.486v3.147h1.376Zm18.464-5.698h-2.02v-1.722h-1.244v1.722h-1.128v1.127h1.128v2.614c0 1.307.532 2.074 1.956 2.074.533 0 1.128-.18 1.543-.415l-.36-1.072c-.36.236-.774.298-1.072.298-.595 0-.83-.36-.83-.948v-2.551h2.02v-1.127h.007Zm10.566-.125c-.712 0-1.19.36-1.487.83v-.712h-1.245v5.698h1.245v-3.209c0-.947.415-1.487 1.19-1.487.235 0 .532.063.774.118l.36-1.19c-.25-.048-.602-.048-.837-.048Zm-15.967.595c-.595-.415-1.425-.595-2.317-.595-1.424 0-2.372.712-2.372 1.84 0 .947.713 1.486 1.957 1.659l.595.062c.65.118 1.01.298 1.01.595 0 .415-.477.712-1.307.712s-1.487-.297-1.902-.594l-.595.947c.65.477 1.543.712 2.434.712 1.66 0 2.614-.774 2.614-1.839 0-1.01-.774-1.542-1.957-1.722l-.594-.062c-.533-.062-.948-.18-.948-.533 0-.415.415-.65 1.072-.65.712 0 1.425.298 1.784.477l.526-1.009Zm33.116-.595c-.712 0-1.189.36-1.486.83v-.712h-1.245v5.698h1.245v-3.209c0-.947.415-1.487 1.19-1.487.234 0 .532.063.774.118l.36-1.176c-.243-.062-.596-.062-.838-.062Zm-15.904 2.974c0 1.722 1.189 2.966 3.028 2.966.83 0 1.425-.18 2.02-.65l-.595-1.009c-.477.359-.947.532-1.487.532-1.01 0-1.722-.712-1.722-1.839 0-1.072.713-1.784 1.722-1.84.533 0 1.01.18 1.487.533l.595-1.01c-.595-.477-1.19-.65-2.02-.65-1.839-.007-3.028 1.245-3.028 2.967Zm11.513 0v-2.849H82.52v.712c-.415-.533-1.01-.83-1.784-.83-1.605 0-2.85 1.245-2.85 2.967s1.245 2.966 2.85 2.966c.83 0 1.424-.297 1.784-.83v.713h1.244v-2.849Zm-4.57 0c0-1.01.65-1.84 1.721-1.84 1.01 0 1.722.775 1.722 1.84 0 1.009-.712 1.839-1.722 1.839-1.065-.062-1.722-.837-1.722-1.839Zm-14.896-2.974c-1.66 0-2.849 1.19-2.849 2.967 0 1.784 1.19 2.966 2.912 2.966.83 0 1.66-.235 2.316-.774l-.595-.892c-.477.359-1.072.594-1.66.594-.774 0-1.541-.359-1.721-1.362h4.211v-.477c.055-1.832-1.016-3.022-2.614-3.022Zm0 1.072c.775 0 1.307.477 1.425 1.362h-2.967c.118-.767.65-1.362 1.542-1.362Zm30.925 1.902v-5.104h-1.245v2.967c-.415-.533-1.01-.83-1.784-.83-1.605 0-2.85 1.245-2.85 2.967s1.246 2.966 2.85 2.966c.83 0 1.424-.297 1.784-.83v.713h1.245v-2.849Zm-4.571 0c0-1.01.65-1.84 1.722-1.84 1.01 0 1.722.775 1.722 1.84 0 1.009-.713 1.839-1.722 1.839-1.072-.062-1.722-.837-1.722-1.839Zm-41.67 0v-2.849h-1.246v.712c-.414-.533-1.01-.83-1.784-.83-1.604 0-2.849 1.245-2.849 2.967s1.245 2.966 2.85 2.966c.83 0 1.424-.297 1.783-.83v.713h1.245v-2.849Zm-4.627 0c0-1.01.65-1.84 1.722-1.84 1.01 0 1.722.775 1.722 1.84 0 1.009-.713 1.839-1.722 1.839-1.072-.062-1.722-.837-1.722-1.839Z"
          />
          <path fill="#FF5A00" d="M73.322 74.51H54.623v33.594h18.699V74.51Z" />
          <path
            fill="#EB001B"
            d="M55.867 91.306c0-6.825 3.209-12.883 8.132-16.797a21.253 21.253 0 0 0-13.18-4.57c-11.811 0-21.368 9.556-21.368 21.367 0 11.811 9.557 21.368 21.368 21.368 4.986 0 9.557-1.722 13.18-4.571-4.93-3.858-8.132-9.971-8.132-16.797Z"
          />
          <path
            fill="#F79E1B"
            d="M98.55 91.306c0 11.811-9.557 21.368-21.368 21.368a21.253 21.253 0 0 1-13.18-4.571c4.986-3.921 8.132-9.971 8.132-16.797 0-6.825-3.209-12.883-8.132-16.797a21.218 21.218 0 0 1 13.173-4.57c11.818 0 21.375 9.618 21.375 21.367Z"
          />
        </g>
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M16 0h96v61.538H16z" />
        </clipPath>
        <clipPath id="c">
          <path fill="#fff" d="M16 66h96v61.538H16z" />
        </clipPath>
      </defs>
    </svg>
  );
}
